import { useAppContextStore } from '@src/contexts/AppContextStore';
import { Dispatch, SetStateAction, useCallback, useState } from 'react';
export function useUniversalState<S>(appContextStoreKey: string, initialState: S | (() => S) = null, defaultValue: S | (() => S) = null): [S, Dispatch<SetStateAction<S>>] {
  const {
    contextStore
  } = useAppContextStore();
  const [stateValue, setStateValue] = useState<S>(initialState || contextStore.get(appContextStoreKey) || defaultValue);
  const setStateValueAndUpdateContextStore = useCallback(newValue => {
    contextStore.set(appContextStoreKey, newValue);
    return setStateValue(newValue);
  }, []);
  return [stateValue, setStateValueAndUpdateContextStore];
}